import { useListClinics } from '@pa/api/admin'
import { adminErrorsAdapter, ErrorsPage, parseErrorsSearch, viewerTimeZone, type ErrorsSearch } from '@pa/staff'
import { createFileRoute, Link } from '@tanstack/react-router'
import { useMemo } from 'react'

/**
 * S-08 Errors, all clinics (UserFlows S-08; Frontend §7.1, §7.2): the shared `errors` feature over the admin adapter
 * (#61–#63) with the Clinic column and the Clinic, Date, Error type and Step filters (clinic options from #38). Times
 * and date presets in the viewer's time zone (API.md §1.4). The drawer links to the clinic's S-04 Errors tab.
 */
export const Route = createFileRoute('/_authed/errors')({
  validateSearch: (raw: Record<string, unknown>): ErrorsSearch => parseErrorsSearch(raw, { admin: true }),
  component: function ErrorsRoute() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const adapter = useMemo(() => adminErrorsAdapter(), [])
    const clinics = useListClinics({ pageSize: '100' }, { query: { staleTime: 60_000 } })
    return (
      <ErrorsPage
        adapter={adapter}
        timeZone={viewerTimeZone()}
        search={search}
        onSearch={(next, opts) => {
          void navigate({ search: next, replace: opts?.replace ?? false })
        }}
        clinics={clinics.data?.items.map((c) => ({ id: c.id, name: c.name }))}
        renderClinicLink={(clinic) => (
          <Link to="/clinics/$clinicId/$tab" params={{ clinicId: clinic.id, tab: 'errors' }}>
            {clinic.name}
          </Link>
        )}
      />
    )
  },
})
